export const topMatchesConstants = {
  LOAD: 'top-matches/LOAD',
  LOAD_SUCCESS: 'top-matches/LOAD_SUCCESS',
  LOAD_FAIL: 'top-matches/LOAD_FAIL',

  LOAD_LIST: 'top-matches/LOAD_LIST',
  GET_DETAILS: 'top-matches/GET_DETAILS',
};
